import { forwardRef } from "react";
import { Calendar, X } from "lucide-react";
import { format } from "date-fns";

const DateRangeInput = forwardRef(
  ({ startDate, endDate, onClick, onClear }, ref) => {
    let value = "Start date – End date";

    if (startDate && !endDate) {
      value = `${format(startDate, "dd MMM yyyy")} - End date`;
    }

    if (startDate && endDate) {
      value = `${format(startDate, "dd MMM yyyy")} - ${format(
        endDate,
        "dd MMM yyyy"
      )}`;
    }

    return (
      <div className="px-date-group" onClick={onClick}>
        <span className="px-date-icon">
          <Calendar size={16} />
        </span>

        <input
          ref={ref}
          value={value}
          readOnly
          className="px-date-input"
        />

        {(startDate || endDate) && (
          <button
            type="button"
            className="px-date-clear"
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
            aria-label="Clear date"
          >
            <X size={14} />
          </button>
        )}
      </div>
    );
  }
);

export default DateRangeInput;
